import React, { useEffect, useState } from "react";
import {
  DialogActions,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import parse from "html-react-parser";
import { Search, Today, CalendarMonth } from "@mui/icons-material";
import DialogLayout from "../../../../partials/content/DialogLayout";
import NumberFormat from "react-number-format";
import { Table } from "react-bootstrap";
import SearchFiscalYear from "../../setup/finance/searchFiscalYear";
import SearchFiscalPeriod from "../../setup/finance/searchFiscalPeriod";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { getCashFlowReport } from "../../../../services/finance/financeReportService";
function CashFlowStatement(props) {
  const {
    companyProfile,
    currentFiscalYear,
    currentFiscalPeriod,
    reload,
  } = useGlobalData();
  const [searchByFiscalYear, setSearchByFiscalYear] = useState(false);
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  const [openSearchFiscalPeriod, setOpenSearchFiscalPeriod] = useState(false);
  const [fiscalYear, setFiscalYear] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalPeriod, setFiscalPeriod] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [totalOperating, setTotalOperating] = useState(0);
  const [totalInvesting, setTotalInvesting] = useState(0);
  const [totalFinancing, setTotalFinancing] = useState(0);
  const [beginningCashBalance, setBeginningCashBalance] = useState(0);
  const [endingCashBalance, setEndingCashBalance] = useState(0);
  const [netCashFlow, setNetCashFlow] = useState(0);
  const [cashFlow, setCashFlow] = useState([]);

  async function getCashFlowReportData(
    fiscalYear = DateTime.now().year,
    fiscalPeriod = DateTime.now().month
  ) {
    const response = await getCashFlowReport(0, fiscalYear, fiscalPeriod);
    const { data } = response.data;
    const {
      cashFlow,
      beginningCashBalance,
      totalOperating,
      totalInvesting,
      totalFinancing,
      netCashFlow,
      endingCashBalance,
    } = data;
    setCashFlow(cashFlow);
    setTotalOperating(totalOperating);
    setTotalInvesting(totalInvesting);
    setTotalFinancing(totalFinancing);
    setBeginningCashBalance(beginningCashBalance);
    setEndingCashBalance(endingCashBalance);
    setNetCashFlow(netCashFlow);
  }

  useEffect(() => {
    getCashFlowReportData(fiscalPeriod.year, fiscalPeriod.month);
  }, [reload]);

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div className="row justify-content-center">
            <div className="col-sm-12 col-md-6 col-lg-4">
              {searchByFiscalYear === true ? (
                <TextField
                  id="fiscalYear"
                  label="Fiscal Year"
                  value={
                    fiscalYear.startMonthName +
                    " " +
                    fiscalYear.year +
                    " - " +
                    fiscalYear.endMonthName +
                    " " +
                    fiscalYear.yearTo
                  }
                  style={{ width: "100%" }}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                        <BootstrapTooltip title="Search By Fiscal Period">
                          <IconButton
                            type="button"
                            aria-label="SearchBy"
                            onClick={() => {
                              setSearchByFiscalYear(false);
                              if (currentFiscalPeriod.ID > 0) {
                                setFiscalPeriod(currentFiscalPeriod);
                                getCashFlowReportData(
                                  currentFiscalPeriod.year,
                                  currentFiscalPeriod.month
                                );
                              }
                            }}
                            edge="end"
                          >
                            <Today />
                          </IconButton>
                        </BootstrapTooltip>
                      </InputAdornment>
                    ),
                    readOnly: true,
                  }}
                />
              ) : (
                <TextField
                  id="fiscalPeriod"
                  label="Fiscal Period"
                  value={fiscalPeriod.monthName + " " + fiscalPeriod.year}
                  style={{ width: "100%" }}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                        <BootstrapTooltip title="Search By Fiscal Year">
                          <IconButton
                            type="button"
                            aria-label="SearchBy"
                            onClick={() => {
                              setSearchByFiscalYear(true);
                              if (currentFiscalYear.ID > 0) {
                                setFiscalYear(currentFiscalYear);
                                /*getCashFlowReportData(
                                  currentFiscalPeriod.year,
                                  currentFiscalPeriod.month
                                );*/
                              }
                            }}
                            edge="end"
                          >
                            <CalendarMonth />
                          </IconButton>
                        </BootstrapTooltip>
                      </InputAdornment>
                    ),
                    readOnly: true,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-sm-12 col-md-10 col-lg-10">
          <div className="card">
            <Table striped borderless size="sm" responsive="xl">
              <tbody>
                <tr>
                  <td
                    className={`${
                      beginningCashBalance > 0
                        ? "bg-success"
                        : beginningCashBalance < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography className="kt-font-bolder text-white">
                      BEGINNING CASH BALANCE
                    </Typography>
                  </td>
                  <td
                    className={`${
                      beginningCashBalance > 0
                        ? "bg-success"
                        : beginningCashBalance < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography
                      component="div"
                      className="kt-font-bolder text-white"
                    >
                      <NumberFormat
                        value={beginningCashBalance}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">
                            {companyProfile.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="bg-secondary px-2" colSpan="2">
                    <Typography className="kt-font-bolder">
                      Operating Cash Flow
                    </Typography>
                  </td>
                </tr>
                {cashFlow && cashFlow.length > 0
                  ? cashFlow.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          {item.categoryID === 1 ? (
                            <tr>
                              <td className="px-5">
                                <Typography className="kt-font-bold text-muted">
                                  {item.accountName}
                                </Typography>
                              </td>
                              <td className="px-2">
                                <Typography
                                  component="div"
                                  className="kt-font-bold text-muted"
                                >
                                  <NumberFormat
                                    value={item.amount}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => (
                                      <div className="float-right">{value}</div>
                                    )}
                                  />
                                </Typography>
                              </td>
                            </tr>
                          ) : null}
                        </React.Fragment>
                      );
                    })
                  : null}
                <tr>
                  <td className="px-5">
                    <Typography className="kt-font-bolder">
                      Net Operating Cash Flow
                    </Typography>
                  </td>
                  <td className="px-2">
                    <Typography component="div" className="kt-font-bolder">
                      <NumberFormat
                        value={totalOperating}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">{value}</div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="bg-secondary px-2" colSpan="2">
                    <Typography className="kt-font-bolder">
                      Investing Cash Flow
                    </Typography>
                  </td>
                </tr>
                {cashFlow && cashFlow.length > 0
                  ? cashFlow.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          {item.categoryID === 2 ? (
                            <tr>
                              <td className="px-5">
                                <Typography className="kt-font-bold text-muted">
                                  {item.accountName}
                                </Typography>
                              </td>
                              <td className="px-2">
                                <Typography
                                  component="div"
                                  className="kt-font-bold text-muted"
                                >
                                  <NumberFormat
                                    value={item.amount}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => (
                                      <div className="float-right">{value}</div>
                                    )}
                                  />
                                </Typography>
                              </td>
                            </tr>
                          ) : null}
                        </React.Fragment>
                      );
                    })
                  : null}
                <tr>
                  <td className="px-5">
                    <Typography className="kt-font-bolder">
                      Net Investing Cash Flow
                    </Typography>
                  </td>
                  <td className="px-2">
                    <Typography component="div" className="kt-font-bolder">
                      <NumberFormat
                        value={totalInvesting}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">{value}</div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="bg-secondary px-2" colSpan="2">
                    <Typography className="kt-font-bolder">
                      Financing Cash Flow
                    </Typography>
                  </td>
                </tr>
                {cashFlow && cashFlow.length > 0
                  ? cashFlow.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          {item.categoryID === 3 ? (
                            <tr>
                              <td className="px-5">
                                <Typography className="kt-font-bold text-muted">
                                  {parse(item.accountName)}
                                </Typography>
                              </td>
                              <td className="px-2">
                                <Typography
                                  component="div"
                                  className="kt-font-bold text-muted"
                                >
                                  <NumberFormat
                                    value={item.amount}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => (
                                      <div className="float-right">{value}</div>
                                    )}
                                  />
                                </Typography>
                              </td>
                            </tr>
                          ) : null}
                        </React.Fragment>
                      );
                    })
                  : null}
                <tr>
                  <td className="px-5">
                    <Typography className="kt-font-bolder">
                      Net Financing Cash Flow
                    </Typography>
                  </td>
                  <td className="px-2">
                    <Typography component="div" className="kt-font-bolder">
                      <NumberFormat
                        value={totalFinancing}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">{value}</div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${
                      netCashFlow > 0
                        ? "bg-success"
                        : netCashFlow < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography className="kt-font-bolder text-white">
                      NET CASH FLOW
                    </Typography>
                  </td>
                  <td
                    className={`${
                      netCashFlow > 0
                        ? "bg-success"
                        : netCashFlow < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography
                      component="div"
                      className="kt-font-bolder text-white"
                    >
                      <NumberFormat
                        value={netCashFlow}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">
                            {companyProfile.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${
                      endingCashBalance > 0
                        ? "bg-success"
                        : endingCashBalance < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography className="kt-font-bolder text-white">
                      ENDING CASH BALANCE
                    </Typography>
                  </td>
                  <td
                    className={`${
                      endingCashBalance > 0
                        ? "bg-success"
                        : endingCashBalance < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography
                      component="div"
                      className="kt-font-bolder text-white"
                    >
                      <NumberFormat
                        value={endingCashBalance}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">
                            {companyProfile.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSearchFiscalYear}
        title="Search Fiscal Year"
        onCloseDialog={() => {
          setOpenSearchFiscalYear(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalYear
          onSelectFiscalYear={(fiscalYear) => {
            setFiscalYear({
              ID: fiscalYear.ID,
              year: fiscalYear.year,
              yearTo: fiscalYear.yearTo,
              startMonth: fiscalYear.startMonth,
              startMonthName: fiscalYear.startMonthName,
              endMonth: fiscalYear.endMonth,
              endMonthName: fiscalYear.endMonthName,
            });
            //getPeriodListData(fiscalYear.ID);
            setOpenSearchFiscalYear(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalYear(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchFiscalPeriod}
        title="Search Fiscal Period"
        onCloseDialog={() => {
          setOpenSearchFiscalPeriod(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalPeriod
          onSelectFiscalPeriod={(fiscalPeriod) => {
            setFiscalPeriod({
              ID: fiscalPeriod.ID,
              fiscalYearID: fiscalPeriod.fiscalYearID,
              year: fiscalPeriod.year,
              month: fiscalPeriod.month,
              monthName: fiscalPeriod.monthName,
              statusID: fiscalPeriod.statusID,
            });
            getCashFlowReportData(fiscalPeriod.year, fiscalPeriod.month);
            setOpenSearchFiscalPeriod(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalPeriod(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default CashFlowStatement;
